import { EventEmitter, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BuyerStatsSummary } from "../dashboard/model/buyer-stats-summary.model";
import { RegionRank } from "../dashboard/model/region-rank.model";
@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(private http: HttpClient) { }
  public buyerStatsData = new EventEmitter<BuyerStatsSummary>
  public regionRankData = new EventEmitter<Array<RegionRank>>

  public tabletWidth: number = 1024;
  public phoneWidth: number = 992;
  public isTabletDisplay: boolean = false;
  public isDesktopDisplay: boolean = false;

  getGradeMatch$(periodType: string, isPreviousWeek: boolean): Observable<BuyerStatsSummary> {
    const url = `${environment.ppxPrivateApi}api/Dashboard/BuyerStats/${periodType}/${isPreviousWeek}`;
    return this.http
      .get<BuyerStatsSummary>(url)
      .pipe(catchError((err) => throwError(err)));
  }

  getRegionRank$(periodType: string, periodOffset: number): Observable<Array<RegionRank>> {
    const url = `${environment.ppxPrivateApi}api/Dashboard/RegionRank/${periodType}/${periodOffset}`;
    return this.http
      .get<Array<RegionRank>>(url)
      .pipe(catchError((err) => throwError(err)));
  }

  getConversionBudget$(): Observable<BuyerStatsSummary> {
    const url = `${environment.ppxPrivateApi}api/Dashboard/ConversionBudget`;
    return this.http
      .get<BuyerStatsSummary>(url)
      .pipe(catchError((err) => throwError(err)));
  }

  getWindDimensions() {
    this.isTabletDisplay =
      window.innerWidth > this.phoneWidth &&
      window.innerWidth <= this.tabletWidth;
    this.isDesktopDisplay = window.innerWidth >= this.tabletWidth;
  }

  convertToPercentage(decimal: number) {
    const percentage = decimal * 100;
    return Math.round(percentage);
  }

  removeDomElement(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.parentNode.removeChild(element);
    }
  }
}

